import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinvadodara() {



  const cardData =
  {
    keyword: 'Taxi Services in Vadodara',
    heading: 'Aaryan Travels: Taxi Services in Vadodara',
    headingDescription: ' Aaryan Travels offers dependable Taxi Services in Vadodara for local travel, airport pickups, office commutes, and outstation journeys. Whether you need a cab for daily travel, family outings, or business meetings, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and comfortable ride. With professional chauffeurs, transparent fares, and 24/7 availability, we make travel across Vadodara convenient and hassle-free. From Alkapuri to Manjalpur, Gotri to Makarpura GIDC, Aaryan Travels provides doorstep pickup and quick taxi booking solutions anywhere in the city. For one-way, round-trip, or long-distance travel from Vadodara, trust Aaryan Travels as your reliable taxi partner.',

    top: 'Top Places to Visit in Vadodara with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lakshmi Vilas Palace",
    "description": "Lakshmi Vilas Palace is one of the grandest royal palaces in India, built by Maharaja Sayajirao Gaekwad III in 1890. It is four times larger than Buckingham Palace and displays a fusion of Indo-Saracenic architecture. Visitors marvel at its ornate interiors, Belgian stained glass, and Durbar Hall. The palace complex also features a museum and golf course. Lakshmi Vilas Palace is Vadodara’s majestic symbol of royal elegance."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug is a sprawling public garden spread over 100 acres, offering a zoo, planetarium, toy train, and Baroda Museum. Families enjoy leisurely walks among fountains, floral displays, and shaded pathways. The museum showcases diverse artifacts including an Egyptian mummy. It is the perfect spot for recreation and education. Sayaji Baug is Vadodara’s green heart of relaxation and culture."
  },
  {
    "title": "EME Temple (Dakshinamurthy Temple)",
    "description": "Managed by the Indian Army, the EME Temple is a unique place of worship built in modern aluminum-clad architecture. It represents unity across religions with elements from Hindu, Islamic, Christian, and Buddhist designs. The serene atmosphere and immaculate premises make it ideal for meditation. Visitors admire its symbolic architecture and peaceful aura. EME Temple is Vadodara’s spiritual emblem of harmony."
  },
  {
    "title": "Ajwa Water Park & Ajwa Lake",
    "description": "Ajwa Water Park is a popular amusement hub featuring exciting slides, wave pools, and rain dance areas. Located next to Ajwa Lake, visitors enjoy boat rides and sunset views over the calm waters. Lush surroundings and fresh air make it perfect for picnics. It is especially loved by families and children. Ajwa is Vadodara’s refreshing blend of fun and tranquility."
  },
  {
    "title": "Maharaja Fateh Singh Museum",
    "description": "Situated within the Lakshmi Vilas Palace estate, the Maharaja Fateh Singh Museum displays a rich collection of royal paintings, bronze sculptures, and antique furniture. Notable works include masterpieces by Raja Ravi Varma. Each gallery reflects the lifestyle and artistic taste of the Gaekwad dynasty. Art lovers find it deeply captivating. The museum is Vadodara’s elegant tribute to heritage and fine arts."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir is a cenotaph built by Maharaja Sayajirao Gaekwad III in memory of the royal family. Its architecture features murals inspired by Indian epics like Mahabharata and Ramayana. The peaceful ambiance offers spiritual serenity for visitors. It serves as a symbol of loyalty and reverence. Kirti Mandir is Vadodara’s tranquil memorial of royal legacy."
  },
  {
    "title": "Sursagar Lake",
    "description": "Sursagar Lake is a scenic waterbody located in the heart of Vadodara, famous for its large Shiva statue rising from the center. Illuminated in the evening, it creates a beautiful lakeside view. Visitors enjoy peaceful strolls along the stone embankments. During festivals, the lake becomes a vibrant gathering spot. Sursagar is Vadodara’s serene reflection of devotion and beauty."
  },
  {
    "title": "Laxmi Vilas Palace Golf Club",
    "description": "Located within the palace grounds, the Laxmi Vilas Golf Club offers a lush 10-hole course surrounded by royal architecture and nature. Peacocks often roam freely across the lawns. Golf enthusiasts enjoy playing in a regal environment. It is also used for high-end social events. The Golf Club is Vadodara’s royal retreat for leisure and sport."
  },
  {
    "title": "Inorbit Mall Vadodara",
    "description": "Inorbit Mall is a premier shopping and entertainment hub featuring international brands, food courts, and multiplex cinema. The lively atmosphere makes it a popular weekend destination for families and youth. Fashion stores and arcade games add to the excitement. It reflects the city’s modern lifestyle. Inorbit Mall is Vadodara’s one-stop destination for fun and fashion."
  },
  {
    "title": "Narmada Canal Viewpoint",
    "description": "The Narmada Canal passing through Vadodara offers picturesque locations perfect for evening drives and roadside relaxation. The calm flowing waters against green landscapes create a soothing experience. Locals often stop here for photography and fresh air. During monsoon, the surroundings turn lush and vibrant. The canal viewpoint is Vadodara’s peaceful escape into nature."
  }
],


"services": [
  {
    "name": "Taxi Services in Vadodara Gujarat",
    "description": "Our Taxi Services in Vadodara, Gujarat, offer comprehensive and reliable transportation solutions tailored to meet the diverse travel needs of residents and visitors alike. Whether you need a quick local ride, an outstation trip, or airport transfers, our fleet of well-maintained sedans, SUVs, and hatchbacks are available 24/7. Each vehicle is driven by professional, verified drivers committed to ensuring a safe, comfortable, and timely journey across Vadodara and surrounding areas."
  },
  {
    "name": "Vadodara Taxi Booking",
    "description": "Booking a taxi in Vadodara has never been easier with our streamlined Vadodara Taxi Booking service. Whether you prefer online or phone bookings, our user-friendly platform guarantees instant confirmations and flexible scheduling options. We cater to single rides, group travels, and corporate bookings with transparent pricing and no hidden charges. Our customer support team is always ready to assist with any special requests or last-minute changes."
  },
  {
    "name": "Cab Services Vadodara Gujarat",
    "description": "Cab Services in Vadodara, Gujarat, are designed to provide safe, efficient, and affordable transportation for all occasions. From daily commutes to weekend getaways, our varied fleet includes sedans, SUVs, and luxury vehicles to suit your preferences and budget. With extensive knowledge of Vadodara's routes and traffic conditions, our drivers ensure you reach your destination quickly and comfortably, every time."
  },
  {
    "name": "Local Taxi Vadodara",
    "description": "Our Local Taxi service in Vadodara is perfect for short-distance travel within the city. Whether you need a ride to the market, office, or hospital, we offer quick pickups, affordable fares, and professional drivers. Available round the clock, our local taxis prioritize customer convenience with easy booking options and real-time tracking, ensuring you never wait long for your ride."
  },
  {
    "name": "Affordable Taxi Vadodara",
    "description": "Affordable Taxi Vadodara offers cost-effective travel solutions without compromising on comfort or safety. Ideal for daily commuters, students, and budget-conscious travelers, this service combines competitive pricing with a quality fleet maintained to the highest standards. With clear pricing structures and no surge charges, you can rely on us for economical and reliable transport anytime."
  },
  {
    "name": "Outstation Cab Vadodara",
    "description": "Travel beyond Vadodara effortlessly with our Outstation Cab service, which covers popular destinations within Gujarat and neighboring states. Whether it’s a business trip, family visit, or leisure travel, our comfortable vehicles and experienced drivers ensure a smooth and stress-free journey. Flexible packages including one-way, round-trip, and multi-day rentals are available, making it easy to plan your outstation travels."
  },
  {
    "name": "Best Cab Vadodara Gujarat",
    "description": "Recognized as one of the Best Cab providers in Vadodara, Gujarat, we pride ourselves on offering exceptional service quality, punctuality, and customer satisfaction. Our fleet comprises the latest models equipped with modern amenities, and our drivers are trained to offer courteous and professional service. Whether for business or leisure, choose us for an unmatched cab experience in Vadodara."
  },
  {
    "name": "Online Cab Booking Vadodara",
    "description": "With Online Cab Booking in Vadodara, you can reserve your taxi quickly and securely from anywhere, anytime. Our intuitive booking platform supports instant confirmations, multiple payment options, and detailed ride tracking. Ideal for busy individuals and corporate clients, this digital convenience saves time and adds flexibility to your travel plans."
  },
  {
    "name": "Gujarat Taxi Service",
    "description": "Our Gujarat Taxi Service extends beyond Vadodara, offering reliable transportation across the state. Whether traveling to Ahmedabad, Surat, or smaller towns, our wide network ensures availability of quality cabs with professional drivers. We specialize in both local and intercity travel, maintaining strict safety protocols and customer-first service at every step."
  },
  {
    "name": "Vadodara Sedan Rental",
    "description": "Vadodara Sedan Rental provides comfortable and stylish sedan cars for personal and business travel. Perfect for airport pickups, city tours, and corporate events, our sedans feature spacious interiors, air conditioning, and modern amenities to make your ride enjoyable. Our flexible rental plans accommodate hourly, daily, and long-term usage according to your needs."
  },
  {
    "name": "SUV Taxi Vadodara",
    "description": "For group travel and extra comfort, our SUV Taxi service in Vadodara offers spacious vehicles with ample luggage space and advanced features. Ideal for family outings, business meetings, or special occasions, our SUVs are driven by experienced chauffeurs who prioritize safety and timely arrivals. Book your SUV taxi today for a premium travel experience within and outside Vadodara."
  },
  {
    "name": "Vadodara City Cabs",
    "description": "Navigate Vadodara effortlessly with our Vadodara City Cabs, designed for quick, convenient urban travel. Whether it's running errands, attending meetings, or visiting tourist spots, our city cabs provide reliable and affordable transportation. With easy booking and prompt service, you can depend on us to get you around town with ease and comfort."
  },
  {
    "name": "Taxi Near Me Vadodara",
    "description": "Searching for a 'Taxi Near Me' in Vadodara? Our extensive network of local drivers ensures that you get a taxi quickly, no matter where you are in the city. With real-time GPS tracking and prompt dispatch, wait times are minimized, allowing you to reach your destination without delay. Enjoy reliable and affordable rides at your fingertips."
  },
  {
    "name": "Trusted Cab Vadodara",
    "description": "As a Trusted Cab provider in Vadodara, we prioritize safety, reliability, and customer satisfaction above all else. Our verified drivers, well-maintained vehicles, and transparent pricing policies have earned us a loyal customer base. Whether it’s a daily commute or an occasional trip, trust us to provide a hassle-free and secure travel experience."
  },
  {
    "name": "Reliable Taxi Vadodara",
    "description": "Our Reliable Taxi service in Vadodara guarantees punctual pickups, courteous drivers, and smooth rides every time. Whether for personal travel or corporate needs, our commitment to quality service ensures that you can plan your journey with confidence. We continuously monitor vehicle conditions and driver performance to maintain high standards across our fleet."
  }
],
"tableData": [
  ["Taxi Services in Vadodara Gujarat", "Vadodara Taxi Booking"],
  ["Cab Services Vadodara Gujarat", "Local Taxi Vadodara"],
  ["Affordable Taxi Vadodara", "Outstation Cab Vadodara"],
  ["Best Cab Vadodara Gujarat", "Online Cab Booking Vadodara"],
  ["Gujarat Taxi Service", "Vadodara Sedan Rental"],
  ["SUV Taxi Vadodara", "Vadodara City Cabs"],
  ["Taxi Near Me Vadodara", "Trusted Cab Vadodara"],
  ["Reliable Taxi Vadodara", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Taxi Services in Vadodara",
    "WhyChoosedescription": "Aaryan Travels offers dependable and convenient taxi services throughout Vadodara for all your travel needs."
  },
  {
    "WhyChooseheading": "Quick and Convenient Pickup Across Vadodara",
    "WhyChoosedescription": "Our drivers are always nearby to ensure prompt pickups and smooth rides anywhere in the city."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned taxis designed for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Vadodara Roads",
    "WhyChoosedescription": "Our professional drivers know Vadodara well to provide efficient and timely rides."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys as per your needs."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers depending on your comfort and luggage preferences."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer taxi services in Vadodara?',
    answer: 'Yes, Aaryan Travels provides reliable and convenient taxi services across Vadodara for both local and outstation travel.',
  },
  {
    question: 'How can I book a taxi in Vadodara with Aaryan Travels?',
    answer: 'You can book your taxi easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of taxis are available for booking in Vadodara?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Can I book a taxi for both local travel and outstation trips from Vadodara?',
    answer: 'Yes, Aaryan Travels provides taxi services for local rides as well as outstation trips from Vadodara to various destinations.',
  },
  {
    question: 'Are the drivers experienced and familiar with Vadodara routes?',
    answer: 'Absolutely. Our drivers are professional, licensed, and well-acquainted with Vadodara and surrounding areas to ensure safe travel.',
  },
  {
    question: 'Is hourly taxi rental available in Vadodara?',
    answer: 'Yes, we offer flexible hourly rental packages for taxi hire in Vadodara.',
  },
  {
    question: 'Are safety and hygiene protocols followed for taxi services in Vadodara?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to protect passengers.',
  },
  {
    question: 'Is taxi booking service in Vadodara available 24x7?',
    answer: 'Yes, Aaryan Travels offers 24x7 taxi booking and services throughout Vadodara.',
  },
  {
    question: 'What payment options are accepted for taxi bookings in Vadodara?',
    answer: 'We accept cash, digital wallets, UPI, and card payments for smooth and secure transactions.',
  },
  {
    question: 'Can I customize pickup and drop-off locations within Vadodara?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Vadodara as per your travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Shah',
    feedback: 'The taxi service by Aaryan Travels in Vadodara was prompt, comfortable, and hassle-free. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Mehta',
    feedback: 'Smooth booking and excellent taxi service in Vadodara. Great experience with Aaryan Travels.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Services in Vadodara, Gujarat",
  "image": "https://aaryantravels.com/assets/images/taxi-services-vadodara.jpg", // replace with actual image URL
  "description": "Reliable and affordable taxi services in Vadodara, Gujarat by Aaryan Travels. Book local, outstation, sedan, and SUV taxis online with trusted and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",  // example rating, update if needed
    "ratingCount": "2100", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1000",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/taxi-services-vadodara"
  }
};





  return (
    <div>

<Helmet>
  <title>Taxi Services in Vadodara | Reliable & Affordable Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable taxi services in Vadodara, Gujarat by Aaryan Travels. Book local, outstation, sedan, and SUV taxis online with trusted and professional drivers."
  />
  <meta
    name="keywords"
    content="Taxi Services in Vadodara Gujarat, Vadodara Taxi Booking, Cab Services Vadodara Gujarat, Local Taxi Vadodara, Affordable Taxi Vadodara, Outstation Cab Vadodara, Best Cab Vadodara Gujarat, Online Cab Booking Vadodara, Gujarat Taxi Service, Vadodara Sedan Rental, SUV Taxi Vadodara, Vadodara City Cabs, Taxi Near Me Vadodara, Trusted Cab Vadodara, Reliable Taxi Vadodara"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceinvadodara;